import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { PageConfigService } from 'src/app/page-config.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-main-footer',
  templateUrl: './main-footer.component.html',
  styleUrls: ['./main-footer.component.scss']
})
export class MainFooterComponent implements OnInit {

  config: any

  constructor( private PageConfigService : PageConfigService, private router : Router,   public translate: TranslateService)
   { this.getSite()
  
    this.PageConfigService.config.subscribe((x) =>{
      this.config = x
    })
    }

  ngOnInit() {
    
  }
  // onClick(){
  //    this.PageConfigService.onClick('ccm');
  //   // this.router.navigate(['/'], { fragment: 'ccm' });
  // }



 






siteType = 'default';

getSite() {
  const host = location.host;

  switch (host) {

    case 'clem.mobi':
    case 'www.clem.mobi':
      this.siteType = 'clem';
      break;

    case 'mam.clem.mobi':
    case 'www.mam.clem.mobi':
      this.siteType = 'mam';
      break;

    case 'remiautopartage.clem.mobi':
    case 'www.remiautopartage.clem.mobi':
    // case 'localhost:4200':
    // case `devghiles.clem.mobi` : 
      this.siteType = 'remi';
      break;

    default:
      this.siteType = 'default';
  }
}


}
